import muiCreateStyles from '@mui/styles/createStyles';
import { Styles } from '@mui/styles';

const createStyles = muiCreateStyles;

export { Styles, createStyles };
